import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { UserProfile } from '../types';

interface ConsentScreenProps {
  profile: UserProfile | null;
  onConsent: (profile?: UserProfile) => void;
  onBack: () => void;
}

export function ConsentScreen({ profile, onConsent, onBack }: ConsentScreenProps) {
  const [hasConsented, setHasConsented] = useState(false);

  const handleContinue = () => {
    if (hasConsented) {
      onConsent(profile || undefined);
    }
  };

  return (
    <div className="mobile-screen flex items-center justify-center mobile-content p-6 bg-background">
      <div className="w-full max-w-2xl space-y-8">
        {/* Header */}
        <div className="text-center">
          <h1 className="title-section">Before We Continue...</h1>
        </div>

        {/* Content */}
        <div className="container-sanctuary p-8 space-y-6">
          <div className="space-y-4">
            <p className="text-contemplative text-center leading-relaxed">
              By continuing, you agree to share your responses with our AI system (Gemini Flash) to power your conversations with your Future Self.
            </p>
            
            <p className="text-contemplative font-medium">
              Your privacy is our highest priority.
            </p>
            
            <ul className="space-y-2">
              <li className="text-contemplative flex items-start">
                <span className="font-bold mr-2">•</span>
                <span><strong>We never see your conversations.</strong> They are processed by the AI and sent back to you.</span>
              </li>
              <li className="text-contemplative flex items-start">
                <span className="font-bold mr-2">•</span>
                <span><strong>Your profile is stored on this device.</strong> You have full control over it.</span>
              </li>
            </ul>
            
            <p className="text-contemplative">
              Please read our full{' '}
              <a href="#" className="text-primary underline hover:no-underline">
                Privacy Policy
              </a>
              {' '}and confirm you understand and agree to this process to continue.
            </p>
          </div>

          {/* Consent Checkbox */}
          <div className="border-t border-border pt-6">
            <div className="flex items-start space-x-3">
              <Checkbox
                id="consent"
                checked={hasConsented}
                onCheckedChange={(checked) => setHasConsented(checked as boolean)}
                className="mt-1"
              />
              <Label htmlFor="consent" className="text-contemplative leading-relaxed cursor-pointer">
                I have read the Privacy Policy and I consent to my anonymized data being processed by Google's AI to power my experience.
              </Label>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col gap-4 pt-6">
            <Button onClick={handleContinue} className="w-full button-sanctuary h-12">
              I Agree, Continue
            </Button>
            
            <Button
              variant="ghost"
              onClick={onBack}
              className="w-full"
            >
              Back
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
